import { useState, useEffect } from 'react';
import {
  getCartVariants,
  getCount,
  getVariantQuantityLimits,
} from '@fff-web/fff-cart';

function useCartData(
  cartDetails,
  products,
  variants,
  prevPurchasedVariantQuantities,
  customizeCampaignDetails
) {
  const [cartData, setCartData] = useState({
    cartVariants: [],
    cartDetails: {},
    initialCredits: {},
    itemsCount: 0,
    customizeCampaignDetails: null,
  });

  useEffect(() => {
    const { initialPurchaseCredit } = cartDetails;
    let cartVariants = getCartVariants(cartDetails, variants, products);
    const count = getCount(cartVariants);
    cartVariants = getVariantQuantityLimits(
      cartVariants,
      prevPurchasedVariantQuantities
    );
    setCartData({
      cartVariants,
      cartDetails,
      initialCredits: { initialPurchaseCredit },
      itemsCount: count,
      customizeCampaignDetails,
    });
  }, [cartDetails, products, variants]);
  return cartData;
}

export default useCartData;
